import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import './index.css';
import RecsCard from './recsCard';

const Recommendations = ({
  title = '',
  recs = [],
  customClass = '',
  showMarker = false,
  from = '',
  recsType = '',
  parentItemName = '',
}) => {
  const restarantSettingFromRedux = useSelector((state) => state.restSetting?.Setting);
  const addOnsId = useMemo(
    () => restarantSettingFromRedux?.addons?.map((addOn) => [...addOn?.itemids]).flat(1),
    [restarantSettingFromRedux]
  );

  return (
    <div className={`recs__container ${customClass}`}>
      <div className='recs__title'>{title}</div>
      <div className='recs__cards-container hideScrollbar'>
        {Array.isArray(recs) &&
          !!recs?.length &&
          recs.map((item) => (
            <RecsCard
              item={item}
              addOnsId={addOnsId}
              from={from}
              recsType={recsType}
              parentItemName={parentItemName}
            />
          ))}
      </div>
      {showMarker && <div className='marker'></div>}
    </div>
  );
};

export default Recommendations;
